<div *ngIf="mode == 'short'; then spinner else symbol"></div>

<ng-template #spinner>
  <div class="spinner-wrapper">
    <mat-spinner color="accent"></mat-spinner>
  </div>
</ng-template>

<ng-template #symbol>
  <svg xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
  >
    <defs>
      <mask id="pd-gui-progress-symbol-mask-element">
        <image x="0"
              y="0"
              width="100"
              height="100"
              xlink:href="/assets/img/progress-mask.svg" />
      </mask>
    </defs>

    <svg mask="url('#pd-gui-progress-symbol-mask-element')">
      <rect *ngIf="mode == 'determinate'"
            [attr.x]="0"
            [attr.y]="0"
            width="100"
            height="100"
            [ngStyle]="fillerStyle"
            class="determinate"
      />

      <rect *ngIf="mode == 'indeterminate'"
            x="0"
            y="0"
            width="100"
            height="100"
            class="indeterminate"
      />
    </svg>

    <image x="0"
            y="0"
            width="100"
            height="100"
            xlink:href="/assets/img/progress-mask-border.svg" />
  </svg>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/controls/progress-overlay/progress-symbol.component.html